<template>
  <div>
    <b-container class="home-container text-left">
      <b-row class="mb-3">
        <b-col sm="12" md="10 mb-lg-4">
          <h1 class="pt-2 mb-lg-4">ESG tanácsadókat oktató intézmények akkreditációja</h1>
        </b-col>
      </b-row>
    </b-container>
    <div class="wrapper pt-3 pb-3 mb-3">
      <b-container class="text-left">
        <b-row class="mb-3 mb-md-3 mt-3">
          <b-col cols="12" lg="12">
            <h2 class="font-weight-bold mb-4">Az akkreditációs eljárás háttere</h2>
            <p>
              A <strong>Magyar Gazdaságfejlesztési Ügynökség</strong> akkreditációs hatóságként jár el az ESG
              tanácsadókat oktató intézmények akkreditációs eljárásának lefolytatása során, valamint vezeti
              nyilvántartásukat. Kizárólag az akkreditált intézmény jogosult ESG tanácsadói képesítés igazolására.
            </p>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="pb-1 pt-3">
      <b-container class="text-left">
        <b-row class="mb-3 mb-md-3 mt-3">
          <b-col cols="12" lg="12">
            <h2 class="font-weight-bold mb-4">
              Mely szervezetek igényelhetik ügyfélként az ESG tanácsadókat oktató intézményként történő akkreditációt?
            </h2>
            <p>
              A nemzeti felsőoktatásról szóló 2011. évi CCIV. törvény 6. §-ának megfelelően államilag elismert
              felsőoktatási intézmény, amely ESG tanácsadókat oktató intézményként a polgári perrendtartásról szóló
              2016. évi CXXX. törvény szerinti gazdálkodó szervezet vagy az államháztartásról szóló 2011. évi CXCV.
              törvény 3. § (2) bekezdésében és (3) bekezdésében meghatározott jogi személy.
            </p>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="wrapper pt-3 pb-3 mb-3">
      <b-container class="text-left">
        <b-row class="mb-3 mb-md-3 mt-3">
          <b-col cols="12" lg="12">
            <h2 class="font-weight-bold mb-4">
              Mely feltételnek kell megfelelnie az ügyfélnek az akkreditációs eljárás során?
            </h2>
            <ul class="mb-3">
              <li>
                nem áll csődeljárás, végelszámolás, kényszertörlési, illetve felszámolási eljárás hatálya alatt;
              </li>
              <li>
                a kérelem benyújtását megelőző utolsó lezárt, teljes üzleti év jóváhagyott éves beszámolója alapján a
                saját tőkéje a jegyzett tőke jogszabályban előírt legkisebb mértéke alá nem csökkent;
              </li>
              <li>
                az Áht. alkalmazása szempontjából megfelel a rendezett munkaügyi kapcsolatok követelményének;
              </li>
              <li>
                nincs érvényben vele szemben az Európai Bizottságnak valamely támogatás visszafizetésére kötelező
                határozata;
              </li>
              <li>
                a kérelem benyújtásának időpontjában az adózás rendjéről szóló 2017. évi CL. törvény szerint
                köztartozásmentes adózónak minősül.
              </li>
              <li>
                rendelkezik legalább hároméves felsőoktatásban akkreditált oktatási tapasztalattal;
              </li>
              <li>
                rendelkezik legalább két-két oktatóval a 30/2024. (VIII.8.) NGM rendelet 1. melléklet 1.3. pontja
                szerinti szakterületeken;
              </li>
              <li>
                rendelkezik legalább két akkreditált ESG tanácsadóval, akik szerepelnek az ESG törvény 41. § (1)
                bekezdése szerinti nyilvántartásban
              </li>
              <li>
                rendelkezik az ESG tanácsadó képzésre vonatkozó saját honlappal;
              </li>
              <li>
                jelenléti képzés folytatása esetén rendelkezik legalább a képzést végzők számának megfelelő különálló
                munkaállomással;
              </li>
              <li>
                a képzést – képzési formától függetlenül – legalább kétszáz órában biztosítja, amelyből legalább a fele
                jelenléti képzés, és amelybe a szakmai gyakorlat időtartama nem számít bele;
              </li>
              <li>
                az ESG tananyagot a rendszeresen változó szabályozási környezetre tekintettel folyamatosan naprakészen
                tartja azzal, hogy az ESG tanácsadók továbbképzésének feladatait is vállalja azzal, hogy a
                továbbképzésben résztvevők részére legalább ötven óra képzést és szakmai konferencia megszervezését
                biztosítja.
              </li>
            </ul>
            <p>
              Felhívjuk szíves figyelmüket, hogy az akkreditált, ESG tanácsadókat oktató intézmény 15 napon belül
              köteles bejelenteni a vállalkozásfejlesztési ügynökségnek, ha az előírásoknak már nem felel meg.
            </p>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div>
      <b-container>
        <b-row>
          <b-col cols="12" lg="12">
            <h2 class="font-weight-bold mb-4">Az eljárás menete</h2>
            <p class="mb-4" style="text-align: left; font-size: 18px;">
              Az akkreditációs eljárás az alábbi főbb lépésekből áll. Az eljárás feltételeivel, és folyamatával
              kapcsolatos, további részletes tudnivalókat az
              <a href="https://vali.hu/static/ESG_Akkreditacios_eljaras_tajekoztato.pdf" target="_blank"
                >Akkreditációs eljárás tájékoztató
              </a>
              tartalmazza.
            </p>
          </b-col>
        </b-row>
        <b-row class="mb-3 ">
          <b-col cols="12" style="margin-left: -2px;">
            <img src="../assets/img/ESG_folyamatabra.jpg" style="max-width: 100%;" class="desktop-image" />
            <img src="../assets/img/ESG_folyamatabra_mobilra.png" style="max-width: 100%;" class="mobile-image" />
          </b-col>
        </b-row>
        <b-row class=" pt-3 pb-1 m-2">
          <b-col cols="12">
            <ul style="text-align: left;">
              <li>
                A benyújtandó dokumentumokat (Akkreditációs kérelem, Megfelelési nyilatkozat) és a és tájékoztatókat a
                <a class="custom-color" href="#letoltheto-dokumentumok">Letölthető dokumentumok</a> között találja.
              </li>
              <li>
                Az eljárás során sem igazgatási szolgáltatási díjat, sem illetéket nem kell fizetni.
              </li>
              <li>
                A jogi hátteret az ESG tanácsadókat oktató intézményként történő akkreditálás részletes eljárási
                szabályairól szóló 244/2024. (VIII. 8.) Korm. rendelet tartalmazza.
              </li>
            </ul>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="wrapper pt-3 pb-3 mb-3">
      <b-container class="text-left">
        <b-row class="mb-3 mb-md-3 mt-3">
          <b-col cols="12" lg="12">
            <h2 class="font-weight-bold mb-4">Mely követelmények vonatkoznak a képzésre?</h2>
            <p>
              A követelményrendszer részletes leírását az ESG tanácsadókat oktató intézményként történő akkreditálás
              követelményrendszeréről, az akkreditált oktató intézményeket tartalmazó nyilvántartás vezetésére vonatkozó
              részletes eljárási szabályokról, valamint az ESG tanácsadói képzésről, továbbá a képzés és a vizsga
              díjáról szóló 30/2024. (VIII.8.) NGM rendelet tartalmazza.
            </p>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="pt-1 pb-1 m3-5">
      <b-container class="text-left">
        <b-row class="mb-3 mb-md-3 mt-3">
          <b-col cols="12" lg="12">
            <h2 class="font-weight-bold mb-4">Akkreditációhoz szükséges dokumentumok benyújtásának módja</h2>
            <p style="font-size: 17px;">
              Az ESG tanácsadókat oktató intézményként történő akkreditálásához szükséges dokumentumokat Hivatali kapun
              keresztül lehet benyújtani a
              <a href="https://vali.hu/static/Hivatali_kapu_tajekoztato.pdf" target="_blank">
                Hivatali kapu tájékoztatóban
              </a>
              szereplő információk szerint.
            </p>
            <!-- <p>
              Akkreditációs kérelmek beadására 2024.08.13-től van lehetőség.
            </p> -->
            <b-button
              variant="primary"
              href="https://tarhely.gov.hu/levelezes/uzenetek/feltoltes/hivatal"
              target="_blank"
              class="custom-button"
            >
              Dokumentumok benyújtása Hivatali kapun
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="wrapper pt-3 pb-3 mb-3">
      <b-container class="text-left">
        <b-row class="mb-3 mb-md-3 mt-3">
          <b-col cols="12" lg="12">
            <h2 class="font-weight-bold mb-4">Milyen joghatásai vannak az akkreditációnak?</h2>
            <p>
              Az ESG tanácsadókat oktató akkreditált intézmény az akkreditációt követően szervezhet ESG tanácsadó
              képzést a hallgatóknak. A képzést követően a hallgatók vizsgát tesznek, azonban az oklevelük nem jogosítja
              fel őket az ESG tanácsadói hivatás ellátására. Amennyiben a végzett hallgató akkreditált ESG-tanácsadóként
              kíván működni, köteles magát az SZTFH-nál ekként akkreditáltatni, és csak ezek után működhet ESG
              tanácsadóként.
            </p>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="pt-3 pb-3 mb-3">
      <b-container class="text-left">
        <b-row class="mb-3 mb-md-3 mt-3">
          <b-col cols="12" lg="12">
            <h2 class="font-weight-bold mb-4">
              Mit kell tenni az akkreditált intézménynek a tanúsítvány lejárata esetén?
            </h2>
            <p>
              Az akkreditáció három évre szól, mert az ESG tudományok és a kapcsolódó nemzetközi környezet gyorsan
              változik. Ezért az akkreditációs tanúsítvány korlátlan alkalommal megújítható új eljárásban, ahol az
              esetleges új feltételeknek való megfelelést is igazolni kell. Az akkreditált ESG tanácsadókat oktató
              intézmény, az akkreditáció érvényességi határidejének lejárta előtt 60 nappal kérheti annak megújítását.
            </p>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="pt-3 pb-3 mb-3">
      <b-container class="text-left">
        <b-row class="mb-3 mb-md-3 mt-3">
          <b-col cols="12" lg="12">
            <h2 class="font-weight-bold mb-4">
              Mit kell tenni az akkreditált intézménynek, ha adataiban változás következik be?
            </h2>
            <p>
              A 244/2024. (VIII. 8.) Korm. rendelet 3/A. § (2) bekezdése alapján az akkreditált, ESG tanácsadókat oktató
              intézmény 15 napon belül köteles bejelenteni a vállalkozásfejlesztési ügynökségnek, ha az alábbiakban
              meghatározott adataiban változás következik be:
            </p>
            <ul>
              <li>az akkreditált, ESG tanácsadókat oktató intézmény hivatalos neve,</li>
              <li>székhelye,</li>
              <li>vezetőjének neve,</li>
              <li>az érintett képzés helyszíne,</li>
              <li>a képzési órák száma,</li>
              <li>a képzési díj bruttó összege,</li>
              <li>a jelenléti képzés aránya,</li>
              <li>valamint a képzés honlapjának elérhetősége.</li>
            </ul>
            <p>
              A benyújtás módjára vonatkozó részletek, valamint további gyakorlati iránymutatások a Kérdések és válaszok
              akkreditált intézményeknek dokumentumban
              <a href="https://vali.hu/static/Kerdesek_es_valaszok_akkreditalt_intézmenyeknek.pdf">találhatóak</a>.
            </p>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <section id="letoltheto-dokumentumok"></section>
    <div>
      <b-container>
        <b-row id="doc_downloads" cols="12" class="text-left mb-4">
          <b-col lg="6">
            <h2 class="mb-4"><strong>Letölthető dokumentumok</strong></h2>
            <div class="download">
              <ul>
                <li>
                  <a
                    class="services-button-wrapper"
                    download
                    target="_blank"
                    href="https://vali.hu/static/ESG_Akkreditacios_kerelem.pdf"
                  >
                    Akkreditációs kérelem
                    <img src="../assets/img/icons/download.svg" />
                  </a>
                </li>
                <li>
                  <a
                    class="services-button-wrapper"
                    download
                    target="_blank"
                    href="https://vali.hu/static/ESG_Megfelelesi_nyilatkozat.pdf"
                  >
                    Megfelelési nyilatkozat
                    <img src="../assets/img/icons/download.svg" />
                  </a>
                </li>
                <li>
                  <a
                    class="services-button-wrapper"
                    download
                    target="_blank"
                    href="https://vali.hu/static/ESG_Akkreditacios_eljaras_tajekoztato.pdf"
                  >
                    Akkreditációs eljárás tájékoztató
                    <img src="../assets/img/icons/download.svg" />
                  </a>
                </li>
                <li>
                  <a
                    class="services-button-wrapper"
                    download
                    target="_blank"
                    href="https://vali.hu/static/Hivatali_kapu_tajekoztato.pdf"
                  >
                    Hivatali kapu tájékoztató
                    <img src="../assets/img/icons/download.svg" />
                  </a>
                </li>
                <li>
                  <a
                    class="services-button-wrapper"
                    download
                    target="_blank"
                    href="https://vali.hu/static/Kerdesek_es_valaszok_akkreditalt_intézmenyeknek.pdf"
                  >
                    Kérdések és válaszok akkreditált intézményeknek
                    <img src="../assets/img/icons/download.svg" />
                  </a>
                </li>
              </ul>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <ESGButton />
  </div>
</template>

<script>
import ESGButton from './ESGButton.vue'
export default {
  name: 'ESGAkkreditacio',
  components: {
    ESGButton
  }
}
</script>

<style scoped>
.desktop-image {
  display: block;
}
.mobile-image {
  display: none;
}

/* Media Query: Mobil nézethez (max szélesség 768px) */
@media only screen and (max-width: 768px) {
  .desktop-image {
    display: none;
  }
  .mobile-image {
    display: block;
  }
}

.download ul {
  list-style-type: none;
  list-style-image: none;
  padding: 0;
}

.download li {
  font-weight: 700;
  background: #f2f8fa;
}

li {
  padding-left: 20px;
  margin-bottom: 10px;
}

.services-button-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 24px;
  padding-top: 24px;
  padding-right: 24px;
}

@media (max-width: 575px) {
  h1 {
    font-size: 24px;
    font-weight: 400;
  }

  h2 {
    font-size: 18px;
    font-weight: 700;
  }
  h3 {
    font-size: 10px;
    font-weight: 700;
  }
}

.expert-wrapper {
  cursor: pointer;
  height: 100%;
}

.expert-image-wrapper {
  height: 100%;
}

.expert-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.expert-title {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.info-box {
  height: 320px;
  background: #d9eee2;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

@media (min-width: 768px) {
  .mobile-image {
    display: none;
  }
}

.wrapper {
  background: #f2f8fa;
}
.wrapper-2 {
  position: relative;
  height: 172px;
  background: #d9eee2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.wrapper-3 {
  background: #f2f8fa;
  border-radius: 0 100px;
}

.img-shadow {
  box-shadow: -38px 35px #d9eee2;
  border-radius: 40px 0px;
}

.info-box {
  height: 320px;
  background: #d9eee2;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.info-box-shadow-1 {
  border-radius: 80px 8px 8px 8px;
}
.info-box-shadow-3 {
  border-radius: 8px 80px 8px 8px;
}

.info-box ul {
  text-align: center;
  /* list-style: inside; */
  list-style-position: inside;
}
.info-box li {
  margin-right: 40px;
}

.funding .list-title {
  margin-bottom: -10px;
}
.funding li {
  margin-left: -25px;
}

.custom-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30%;
}

.custom-color {
  color: #00903c;
}

@media (max-width: 992px) {
  .wrapper {
    margin-bottom: 2rem;
  }
  .wrapper-2 {
    height: 222px;
  }

  .info-box {
    margin-bottom: 80px;
  }
  .custom-button {
    width: 100%;
  }
}
</style>
